import React from 'react'
import PropTypes from 'prop-types'

import { Empty, Row, Card, Space, Dropdown } from 'antd'
import { dropdownObjectMenu } from '../Menu/options'

const FolderIcon = require('../../../assets/icons/fm-folder.png')
const DocumentIcon = require('../../../assets/icons/fm-document.png')

const propTypes = {
  item: PropTypes.object,
  onClickFolder: PropTypes.func.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
  onDownloadFolder: PropTypes.func.isRequired,
  showRenameForm: PropTypes.func.isRequired,
  onDeleteFile: PropTypes.func.isRequired,
  onDeleteFolder: PropTypes.func.isRequired,

  allowRename: PropTypes.bool.isRequired,
  allowDelete: PropTypes.bool.isRequired,
  allowZip: PropTypes.bool.isRequired
}

const defaultProps = {
  item: { name: 'Example', key: 'path', resourceId: 'aa' }
}

const Icon = (props) => {
  const {
    meta,
    onDownloadFile,
    onDownloadFolder,
    showRenameForm,
    onDeleteFile,
    onDeleteFolder,
    allowRename,
    allowDelete,
    allowZip
  } = props

  const isFolder = meta?.type === 'folder'
  const menu = dropdownObjectMenu(meta, { onDeleteFile, onDeleteFolder, allowRename, allowDelete, allowZip })

  const onClick = () => (isFolder ? props.onClickFolder(props.meta) : props.onDownloadFile(props.meta))

  const onClickDropdown = ({ key }) => {
    if (key === 'rename') {
      showRenameForm(meta)
    }

    if (key === 'download_file') {
      onDownloadFile(meta)
    }

    if (key === 'download_folder') {
      onDownloadFolder(meta)
    }
  }

  return (
    <Dropdown menu={{ items: menu, onClick: onClickDropdown }} trigger={['contextMenu']}>
      <Card hoverable style={{ padding: '10px 5px' }} bodyStyle={{ padding: 16 }} onClick={onClick}>
        <img alt='folder' src={isFolder ? FolderIcon : DocumentIcon} width='60px' />
        <p style={{ margin: 0 }}>{meta?.name}</p>
      </Card>
    </Dropdown>
  )
}

const Grid = (props) => {
  const {
    data,
    onClickFolder,
    onDownloadFolder,
    onDownloadFile,
    showRenameForm,
    onDeleteFile,
    onDeleteFolder,
    loading,
    allowRename,
    allowDelete,
    allowZip
  } = props

  if (loading) {
    return null
  }

  if ((data?.data || []).length === 0) {
    return <Empty />
  }

  return (
    <Row>
      <Space size={[8, 16]} wrap align='start'>
        {(data?.data || []).map((item) => (
          <Icon
            meta={item}
            key={item?.fullname?.toString()}
            onClickFolder={onClickFolder}
            onDownloadFolder={onDownloadFolder}
            onDownloadFile={onDownloadFile}
            showRenameForm={showRenameForm}
            onDeleteFile={onDeleteFile}
            onDeleteFolder={onDeleteFolder}
            allowRename={allowRename}
            allowDelete={allowDelete}
            allowZip={allowZip}
          />
        ))}
      </Space>
    </Row>
  )
}

Grid.propTypes = propTypes
Grid.defaultProps = defaultProps

export default Grid
